import useSessionStorageState from 'use-session-storage-state'

export const useRecentEnvironment = () => useSessionStorageState<string>('nw-recent-environment')
